import React from "react";
import { Row, Col } from "antd";
import {
  StatusDescriptionAfterResearch,
  TimelineDot,
  FirsrtStatusAfterResearch,
  VerticalLineDesktopRel,
  SecondStatusAfterIssuingGrant,
  StatusDescriptionAfterStepsMobile,
  TimelineDotMobile,
  FirstStatusAfterRecommendMobile,
  VerticalLineShorter,
  SecondStatusAfterIssuingGrantMobile,
  timelineDot,
  StatusDescriptionAfterIssuingGrant,
  colMinHeight
} from "../../Epics/Grants/Pages/HowItWorks/styles";
import TooltipComponent from "../Info/Tooltip/TooltipComponent";

export default ({
  statusTitle,
  statusOne,
  statusOneTooltip,
  statusTwo,
  statusTwoTooltip,
  isMobile,
  type
}) => {
  return (
    <>
      {!isMobile ? (
        <>
          <Row data-test={`contentAfterStep${type}DesktopWrapper`} >
            <Col span={11}>
              {
                  type === 4 ?
                (  <StatusDescriptionAfterIssuingGrant>
                  {statusTitle}
                </StatusDescriptionAfterIssuingGrant>):
              <StatusDescriptionAfterResearch>
                {statusTitle}
              </StatusDescriptionAfterResearch>}
            </Col>
            <Col span={2}>
              <Col span={12} offset={6}>
                <TimelineDot></TimelineDot>
              </Col>
            </Col>
            <Col span={11}>
              <FirsrtStatusAfterResearch>
                {statusOne}
                <TooltipComponent text={statusOneTooltip} isHtml={true} />
              </FirsrtStatusAfterResearch>
            </Col>
          </Row>
          <VerticalLineDesktopRel></VerticalLineDesktopRel>
          <Row>
            <Col span={11}></Col>
            <Col span={2}>
              <Col span={12} offset={6}>
                <TimelineDot></TimelineDot>
              </Col>
            </Col>
            <Col span={11}>
              <SecondStatusAfterIssuingGrant>
                {statusTwo}
                <TooltipComponent text={statusTwoTooltip} isHtml={true} />
              </SecondStatusAfterIssuingGrant>
            </Col>
          </Row>
        </>
      ) : (
        <Row data-test={`contentAfterStep${type}MobileWrapper`}>
          <Col span={{ xs: 24, sm: 24, md: 8, lg: 8 }} style={colMinHeight}>
            <StatusDescriptionAfterStepsMobile>
              {statusTitle}
            </StatusDescriptionAfterStepsMobile>
          </Col>
          <Col>
            <TimelineDotMobile></TimelineDotMobile>
          </Col>
          <Col style={colMinHeight}>
            <FirstStatusAfterRecommendMobile>
              {statusOne}
              <TooltipComponent text={statusOneTooltip} isHtml={true} />
            </FirstStatusAfterRecommendMobile>
          </Col>
          <VerticalLineShorter></VerticalLineShorter>
          <Col style={timelineDot}>
            <TimelineDotMobile></TimelineDotMobile>
          </Col>
          <Col>
            <SecondStatusAfterIssuingGrantMobile>
              {statusTwo}
              <TooltipComponent text={statusTwoTooltip} isHtml={true} />
            </SecondStatusAfterIssuingGrantMobile>
          </Col>
        </Row>
      )}
    </>
  );
};
